import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { SlotRequestStatus } from "@/constants/entity-status";
import { capitalize } from "lodash";
import { RequestStatusBadge } from "../../badge/RequestStatusBadge";
import { SlotRequestDetail } from "@/pages/grain-requests/slot-requests/schema/slot-requests.schema";

interface Props {
  slotRequest?: SlotRequestDetail | null;
}

export const SlotRequestDetailMainDataCard = ({ slotRequest}: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform={"uppercase"}
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>
          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Fecha:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {dayjs(slotRequest?.fechaSolicitud).format("DD/MM/YYYY")}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Titular:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{slotRequest?.titular}</Text>
            </GridItem>
                     <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Procedencia:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">
                {slotRequest?.procedencia}
              </Text>
            </GridItem>

          </Grid>
        </Flex>
      </GridItem>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform={"uppercase"}
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>
          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Grano:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {capitalize(slotRequest?.grano.toLocaleLowerCase())}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Cosecha:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{slotRequest?.cosecha}</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">
                <RequestStatusBadge
                  status={slotRequest?.estado as SlotRequestStatus}
                />
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
